import { t } from 'i18next';

/**
 * Formats the price for display
 * @param {number|string|null|undefined} price - The price value
 * @param {string|null|undefined} priceType - Price type: 'fixed' or 'negotiable'
 * @param {boolean|null|undefined} isNegotiable - Whether price is negotiable
 * @param {boolean|null|undefined} isBarter - Whether it's barter
 * @param {string} currency - Currency symbol (default: i18n currencySymbol)
 * @returns {string} Formatted price string
 */
export const formatPrice = (
    price,
    priceType = null,
    isNegotiable = null,
    isBarter = false,
    currency = t('₸') || 'тг.'
) => {
    // If barter, show barter text
    if (isBarter) {
        return t('barter') || 'Бартер';
    }

    // Check if price is negotiable
    if (isNegotiable === true || priceType === 'negotiable' || price === null || price === undefined) {
        return t('negotiable') || 'Договорная';
    }

    // If price is 0 or empty string, show free
    if (price === 0 || price === '0' || price === '') {
        return t('free') || 'Бесплатно';
    }

    // Format numeric price
    const numPrice = parseFloat(price);
    if (isNaN(numPrice)) {
        return t('negotiable') || 'Договорная';
    }

    return `${numPrice.toLocaleString('ru-RU')} ${currency}`;
};

/**
 * Formats price with fallback for display in components
 * @param {object} item - Item/advertisement object
 * @param {string} currency - Currency symbol (default: i18n currencySymbol)
 * @returns {string} Formatted price string
 */
export const formatItemPrice = (item, currency = t('₸') || 'тг.') => {
    if (!item) {
        return t('negotiable') || 'Договорная';
    }

    return formatPrice(
        item.price,
        item.price_type || item.priceType,
        item.is_negotiable || item.isNegotiable,
        item.barter || item.is_barter,
        currency
    );
};

